import {loadProductJson} from '@/product/product-selection/load-product-json';
import {steppedProductSelectorSettingsSchema} from '@/settings/types';
import {h} from 'preact';
import register from 'preact-custom-element';
import ProductSelectorOTPGifts from './ProductSelectorOTPGifts';
import { otpSettingsArrSchema } from '@/otp-gifts/types';

function loader({
  product,
  settings: settingsJson,
  buystackSettings
}: ProductSelectorOTPGiftsProps) {
  //  TODO: move this into its own function with logging
  const otpSettingsArr = otpSettingsArrSchema.parse(JSON.parse(buystackSettings));

  loadProductJson(product);

  const settings = steppedProductSelectorSettingsSchema.parse(
    JSON.parse(settingsJson)
  );

  return h(ProductSelectorOTPGifts, {
    settings,
    otpSettingsArr
  });
}

register(loader, 'product-selector-otp-gifts', ['product', 'settings', 'buystackSettings']);

type ProductSelectorOTPGiftsProps = {
  product: string;
  settings: string;
  buystackSettings: string;
};
